import React from "react";
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';



function AlertMI(props) 
{
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Alert=({type="error",mensaje,close})=>
{
  const mensajeConSaltosDeLinea = typeof mensaje === "string" ? mensaje.split("\n").map((linea, index) => (
    <React.Fragment key={index}>
      {linea}
      <br />
    </React.Fragment>
  )) : mensaje;


  return  <Snackbar open={mensaje} autoHideDuration={6000} onClose={close}>
  <AlertMI  onClose={close} severity={type}>
    {mensajeConSaltosDeLinea}
  </AlertMI>
</Snackbar>
}

export default Alert;